import { ThemeProp } from "../../../styles/theme";
import styled from "@emotion/styled";

export const TokensSecondRow = styled.div<ThemeProp>(({ theme }) => ({
  minWidth: 0,
  overflow: "hidden",
  textOverflow: "ellipsis",
  color: theme.font.secondary.default,
  fontWeight: theme.fontWeights["work-sans-2"],
  fontSize: theme.fontSize["4"],
  whiteSpace: "nowrap",
}));
